/// <amd-module name="Wit/WorkItemForm/Links/Controls/AddLinkButton" />
import * as React from "react";
import * as Resources from "Wit/WorkItemForm/Resources";
import { Button } from "VSSUI/Button";
import { IContextualMenuProps, MenuButton } from "VSSUI/Menu";
import { RegisteredLinkTypeNames } from "Wit/WorkItemLinksRegistration/Constants";
import { LinkTypeFilter } from "Wit/Common/Utils/WorkItemUtils/LinkTypeFilter";

interface IAddLinkButtonProps {
    primary?: boolean;
    isNewItemLinkDisabled?: boolean;
    onLinkToNewItem: () => void;
    onLinkToExistingItem: () => void;
    linkTypeFilter: LinkTypeFilter;
}

export function AddLinkButton({ 
    primary, 
    isNewItemLinkDisabled, 
    onLinkToExistingItem, 
    onLinkToNewItem, 
    linkTypeFilter 
}: IAddLinkButtonProps) {
    const shouldIncludeRelatedWorkLinks = linkTypeFilter(RegisteredLinkTypeNames.Related);

    if (!shouldIncludeRelatedWorkLinks) {
        // Only related work item links support adding new items, so if we are
        // not handling that link type, a single-purpose button is all we need.
        return <Button subtle text={Resources.AddLink} onClick={onLinkToExistingItem} />;
    }

    const menu: IContextualMenuProps = {
        menuProps: {
            id: "add-link-menu",
            items: [
                {
                    id: "existing-item",
                    groupKey: "add-link-actions",
                    iconProps: { iconName: "Link" },
                    text: Resources.AddLinkToExistingItemButtonLabel,
                    onActivate: onLinkToExistingItem
                },
                {
                    id: "new-item",
                    groupKey: "add-link-actions",
                    iconProps: { iconName: "Edit" }, // TODO: the current icon is a clipboard with a checkmark, which is not very illuminating. This isn't much better.
                    text: Resources.AddLinkToNewItemButtonLabel,
                    onActivate: onLinkToNewItem,
                    disabled: isNewItemLinkDisabled
                }
            ]
        }
    };

    return <MenuButton primary={primary} subtle={!primary} text={Resources.AddLink} contextualMenuProps={menu} />;
}
